import "./shapediver.js";
import "./tomselect.js";

window.addEventListener("draft:summary_applied", (e) => {
  const summary = e.detail && e.detail.summary ? e.detail.summary : null;
  if (summary) {
    populateInputsFromSummary(summary);
  }
});

window.updateDescritivo = function (productId) {
  const mainProductPrice = document.querySelector("#main-product-price");
  // O elemento alvo onde o HTML será injetado
  const memorialElement = document.getElementById("memorialDescritivo");

  // [CORREÇÃO CRÍTICA] Se o input de preço ou o container do memorial não existem, PARA.
  // Isso evita o erro "Cannot set properties of null" que está no seu console.
  if (!mainProductPrice || !memorialElement) return;

  const mainProductPriceValue = parseInt(mainProductPrice.value) || 0;
  const upsellProductsByCategory = {};
  let upsellPrice = 0;

  // Percorre cada item do produto e verifica se está selecionado
  document.querySelectorAll(".product-item").forEach((item) => {
    const categoryName = item
      .closest(".category-block")
      .querySelector("h2").innerText;
    const productName = item.querySelector(
      ".product-item-block span"
    ).innerText;
    const productPrice = parseInt(item.dataset.price) || 0;
    let currentProductTotalPrice = 0;

    const pId = item.dataset.productId;
    const sectionElement = item.closest(".mobiliario-section");
    const sectionName = sectionElement
      ? sectionElement.querySelector(".section-title").innerText
      : "";
    const sectionSlug = sectionName
      ? sectionName.toLowerCase().replace(/[^\w]+/g, "-")
      : "";

    let descriptionInputSelector = sectionSlug
      ? `#descritivo_${pId}_${sectionSlug.replace(/[^a-z0-9-]/g, "")}`
      : `input[name="descritivo_${pId}"], #descritivo_${pId}`;

    let descriptionInput = item.querySelector('input[type="hidden"]');
    if (!descriptionInput)
      descriptionInput = document.querySelector(descriptionInputSelector);
    if (!descriptionInput) return;

    let description = descriptionInput.value.replace(/\n/g, "<br>");

    const quantityInput = item.querySelector('input[type="number"]');
    const radioInputs = item.querySelectorAll('input[type="radio"]');
    let radioInput = null;
    if (radioInputs.length > 0)
      radioInputs.forEach((input) => {
        if (input.checked) radioInput = input;
      });
    const revestimentoChecked =
      radioInput && radioInput.name.includes("revestimento")
        ? radioInput
        : null;
    const fileInputs = item.querySelectorAll('input[type="file"]');

    let selected = false;
    let details = "";
    let displayName = productName;

    if (quantityInput && quantityInput.value >= 1) {
      selected = true;
      displayName = `${quantityInput.value}x ${productName}`;
      currentProductTotalPrice = quantityInput.value * parseInt(productPrice);
    } else if (radioInput && parseInt(radioInput.value) > 0) {
      selected = true;
      currentProductTotalPrice = parseInt(productPrice);
    } else if (fileInputs.length > 0) {
      const fileDetails = Array.from(fileInputs).reduce((acc, input) => {
        const files = Array.from(input.files);
        files.forEach((file) => acc.push(`Arquivo: ${file.name}`));
        return acc;
      }, []);
      if (fileDetails.length > 0) {
        selected = true;
        details = fileDetails.join(",<br/>");
      }
    } else if (revestimentoChecked) {
      selected = true;
      details = `Cor: ${revestimentoChecked.dataset.colorText}`;
    }

    if (selected) {
      upsellPrice += currentProductTotalPrice;
      let categoryDisplayName = categoryName;
      if (sectionName && categoryName === "Mobiliário")
        categoryDisplayName = `${categoryName} - ${sectionName}`;
      if (!upsellProductsByCategory[categoryDisplayName])
        upsellProductsByCategory[categoryDisplayName] = [];
      upsellProductsByCategory[categoryDisplayName].push({
        name: displayName,
        description: description,
        details: details,
      });
    }
  });

  // Gerar HTML
  let html = "";
  for (const categoryName in upsellProductsByCategory) {
    html += `<div class="item-content"><h5>${categoryName}</h5>`;
    upsellProductsByCategory[categoryName].forEach((product) => {
      html += `<div class="item"><h6>${product.name}</h6><p>${product.description}</p>`;
      if (product.details) html += `<p><em>${product.details}</em></p>`;
      html += `</div>`;
    });
    html += `</div>`;
  }

  const totalPrice = parseInt(mainProductPriceValue) + upsellPrice;

  // [SEGURANÇA] Inserção no DOM (Só acontece se memorialElement existe)
  memorialElement.innerHTML = html;

  const bdiPrice = document.querySelector(".single-product-price bdi");
  if (bdiPrice)
    bdiPrice.innerHTML = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    })
      .format(totalPrice)
      .trim();

  const totalEl = document.querySelector(".total-price");
  if (totalEl)
    totalEl.innerHTML = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    })
      .format(totalPrice)
      .trim();

  const installmentValue = totalPrice / 4;
  const formattedInstallment = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  })
    .format(installmentValue)
    .trim();

  let installmentElement = document.querySelector(".product-installments");
  if (installmentElement)
    installmentElement.textContent = `em até 4x de ${formattedInstallment} no boleto`;
};

document.addEventListener("DOMContentLoaded", () => {
  updateDescritivo();
});

async function populateInputsFromSummary(summary) {
  if (!summary || !Array.isArray(summary.items)) return;

  try {
    window.isProgrammaticUpdate = true;
    summary.items.forEach((it) => {
      const pid = it.product_id;
      const qty = parseInt(it.quantity, 10) || 0;
      const context = it.meta && it.meta.context ? String(it.meta.context) : "";

      // ---- número (quantidade) ----
      const qSelector = context
        ? `.quantity-input[data-id="${pid}"][data-context="${context}"]`
        : `.quantity-input[data-id="${pid}"]`;
      const qInput = document.querySelector(qSelector);
      if (qInput) {
        const old = parseInt(qInput.value, 10) || 0;
        if (old !== qty) {
          qInput.value = qty;
        }
      }

      // [ Lógica Sim/Não]
      const yesSelector = context
        ? `input[type="radio"][data-id="${pid}"][data-context="${context}"][value="1"]`
        : `input[type="radio"][data-id="${pid}"][value="1"]`;
      const noSelector = context
        ? `input[type="radio"][data-id="${pid}"][data-context="${context}"][value="0"]`
        : `input[type="radio"][data-id="${pid}"][value="0"]`;

      const yes = document.querySelector(yesSelector);
      const no = document.querySelector(noSelector);

      if (yes && no) {
        const shouldBeYes = qty > 0;

        // Força o estado visual correto sem disparar lógica do ShapeDiver (graças à flag)
        if (shouldBeYes && !yes.checked) {
          yes.checked = true;
          no.checked = false;
        } else if (!shouldBeYes && !no.checked) {
          no.checked = true;
          yes.checked = false;
        }
      }

      // ---- rádios de revestimento (produto 86) ----
      if (pid === 86 && it.meta) {
        const cor = it.meta.revestimento || "";
        const hex = it.meta.color_hex || "";
        const param = it.meta.param_id || "";

        // tenta achar o input pelo param_id + color_hex
        let rSelector = `input[type="radio"][data-id="86"][data-name="${param}"]`;
        if (hex) rSelector += `[data-color-hex="${hex}"]`;
        else if (cor) rSelector += `[data-color-text="${cor}"]`;

        const radio = document.querySelector(rSelector);
        if (radio && !radio.checked) {
          radio.checked = true;
          // console.log(`Revestimento marcado automaticamente: ${cor || hex}`);
        }
      }
    });
    updateDescritivo();
  } catch (err) {
    console.error("populateInputsFromSummary error", err);
  } finally {
    window.isProgrammaticUpdate = false;
  }
}

function closeModal() {
  const activeModal = document.querySelector(".modal.active");

  activeModal.classList.remove("active");
}

const handleOpenModal = document.querySelectorAll(".handle-modal");
const handleCloseModal = document.querySelectorAll(".close-modal");

handleCloseModal.forEach((item) => {
  item.addEventListener("click", () => {
    closeModal();
  });
});

handleOpenModal.forEach((item) => {
  item.addEventListener("click", () => {
    const modal = document.querySelector(
      `.modal[data-target="${item.dataset.target}"]`
    );

    modal.classList.add("active");
  });
});

// URL para adicionar no carrinho
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelector(".purchase-button")
    ?.addEventListener("click", async () => {
      document.querySelector(".purchase-button").classList.add("loading");

      try {
        const cameras = [
          { camera: topCamera, name: "top_view" },
          { camera: frontCamera, name: "front_view" },
          { camera: bottomCamera, name: "bottom_view" },
          { camera: perspectiveCamera, name: "perspective_view" },
        ];

        for (const { camera, name } of cameras) {
          await exportView(camera, name);
        }
      } catch (error) {
        alert("erro");
        console.error("Erro ao exportar as imagens:", error);
        document.querySelector(".purchase-button").classList.remove("loading");
      }

      var productIds = [];
      var additionalParams = [];
      var mainProductInput = document.getElementById("main-product-id");
      var mainProductInputEventId = document.getElementById(
        "main-product-event-id"
      );
      var mainProductInputEventName = document.getElementById(
        "main-product-event-name"
      );
      var mainProductInputEventLocal = document.getElementById(
        "main-product-event-local"
      );
      var mainProductInputEventDate = document.getElementById(
        "main-product-event-date"
      );
      var mainProductInputPreviewImages = document.getElementById(
        "main-product-preview-images"
      );
      var mainProductId = mainProductInput ? mainProductInput.value : null;

      if (mainProductId) {
        productIds.push(mainProductId + ":1");
        additionalParams.push(
          "event_id_" +
            mainProductId +
            "=" +
            encodeURIComponent(mainProductInputEventId.value)
        );
        additionalParams.push(
          "event_name_" +
            mainProductId +
            "=" +
            encodeURIComponent(mainProductInputEventName.value)
        );
        additionalParams.push(
          "event_local_" +
            mainProductId +
            "=" +
            encodeURIComponent(mainProductInputEventLocal.value)
        );
        additionalParams.push(
          "event_date_" +
            mainProductId +
            "=" +
            encodeURIComponent(mainProductInputEventDate.value)
        );
        additionalParams.push(
          "event_preview_images_" +
            mainProductId +
            "=" +
            encodeURIComponent(mainProductInputPreviewImages.value)
        );

        const orderImages = Object.entries(uploadedImages)
          .map(([type, url]) => `${type}:${url}`)
          .join("|");
        additionalParams.push(
          "order_images_" +
            mainProductId +
            "=" +
            encodeURIComponent(orderImages)
        );
      }

      document
        .querySelectorAll('input[type="number"]')
        .forEach(function (input) {
          var productId = input.dataset.id;
          if (productId && input.value > 0) {
            productIds.push(productId + ":" + input.value);
          }
        });

      document
        .querySelectorAll('input[type="radio"]:checked')
        .forEach(function (input) {
          var productId = input.dataset.id;
          if (productId) {
            if (input.value >= 2) {
              productIds.push(productId + ":" + input.value);
            } else if (input.value != 0) {
              productIds.push(productId + ":1");
            }

            var colorText = input.dataset.colorText;
            if (colorText) {
              additionalParams.push(
                "cor_" + productId + "=" + encodeURIComponent(colorText)
              );
            }
          }
        });

      // 🔄 Redireciona para a página de contrato (ajustado)
      // Aqui assumimos que o ID do pedido está disponível em um input hidden com id="order-id"
      const orderInput = document.getElementById("order-id");
      const orderId = orderInput ? orderInput.value : null;

      if (!orderId) {
        alert("Erro: ID do pedido não encontrado.");
        document.querySelector(".purchase-button").classList.remove("loading");
        return;
      }

      // Se você tiver a URL via variável global PHP (melhor prática)
      // const contractUrl = ContratoVars.contractUrl;
      // Caso contrário, define o slug manualmente:
      const contractUrl = `${window.location.origin}/contrato/`;

      // Cria a URL com o order_id e possíveis parâmetros adicionais
      let url = `${contractUrl}?order_id=${encodeURIComponent(orderId)}`;

      if (additionalParams.length > 0) {
        url += "&" + additionalParams.join("&");
      }
      if (productIds.length > 0) {
        url += "&" + productIds.join("&");
      }

      // Redireciona para a página de contrato
      window.location.href = url;
    });
});

// 8x8
document.addEventListener("change", function (event) {
  const mainProductShapeDiver = document.querySelector(
    "#main-product-shapediver"
  );
  // console.log("TCL: mainProductShapeDiver", mainProductShapeDiver);

  if (!mainProductShapeDiver || mainProductShapeDiver.value !== "0") return;

  // console.log("TCL: event", event);
  const quadroInputs = document.querySelectorAll(
    'input[data-name="68060fa1-144d-46a0-9f16-1e04e78f3e78"]'
  );
  const depositoInputs = document.querySelectorAll(
    'input[data-name="377c77ec-90e8-4a14-902b-8444535bfcb6"]'
  );
  const salaInputs = document.querySelectorAll('input[data-name="sala"]');
  const frigobarInputs = document.querySelectorAll(
    'input[data-name="5abaf59f-83f8-494d-a836-fd1bb1a4a0fd"]'
  );
  const geladeiraInputs = document.querySelectorAll(
    'input[data-name="8998726b-e18a-4f86-9d17-cbf36e269234"]'
  );

  // Seleciona os inputs relevantes
  const quadroInput = document.querySelector(
    'input[data-name="68060fa1-144d-46a0-9f16-1e04e78f3e78"]:checked'
  );
  const depositoInput = document.querySelector(
    'input[data-name="377c77ec-90e8-4a14-902b-8444535bfcb6"]:checked'
  );
  const salaInput = document.querySelector('input[name="sala"]');
  const frigobarInput = document.querySelector(
    'input[data-name="5abaf59f-83f8-494d-a836-fd1bb1a4a0fd"]:checked'
  );
  const geladeiraInput = document.querySelector(
    'input[data-name="8998726b-e18a-4f86-9d17-cbf36e269234"]:checked'
  );

  // Recupera os valores dos inputs
  const salaValue = salaInput ? salaInput.value : null; // "0", "1" ou "2"
  const quadroValue = quadroInput ? quadroInput.value : null; // "1" ou "0"
  const depositoValue = depositoInput ? depositoInput.value : null; // "0" ou "1"
  const depositoDataValue = depositoInput
    ? depositoInput.dataset.deposito
    : null; // "0" ou "1"
  const frigobarValue = frigobarInput ? frigobarInput.value : null; // "0" ou "1"
  const geladeiraValue = geladeiraInput ? geladeiraInput.value : null; // "0" ou "1"

  // Lógica de restrições para o quadro
  const quadroPermitido =
    (!depositoDataValue ||
      depositoValue === "0" ||
      (depositoValue === "1" && depositoDataValue !== "1")) &&
    salaValue !== "2";
  // console.log("TCL: quadroPermitido", quadroPermitido);

  // Atualiza os estados dos inputs de quadro
  quadroInputs.forEach((input) => {
    if (!quadroPermitido) {
      // Marca o input "0", desabilita os outros e adiciona opacidade ao item
      if (input.value === "0") input.checked = true;
      input.disabled = true;
    } else {
      input.disabled = false;
    }
  });

  // Atualiza os estados dos inputs de depósito baseado no quadro
  depositoInputs.forEach((input) => {
    if (
      (quadroValue === "1" && input.dataset.deposito === "1") ||
      (salaValue === "2" && input.dataset.deposito === "0")
    ) {
      // Desabilita depósitos com data-deposito="0" se o quadro estiver marcado como "sim"
      input.disabled = true;
    } else {
      // Reabilita depósitos caso o quadro não esteja marcado como "sim"
      input.disabled = false;
    }
  });

  // Lógica 3: Bloquear salaInput com valor "2" se quadroValue não for válido
  salaInputs.forEach((input) => {
    // console.log("TCL: depositoDataValue", depositoDataValue);
    if (
      (input.value === "1" && quadroValue === "1") ||
      (input.value === "1" &&
        depositoDataValue === "0" &&
        depositoValue === "1")
    ) {
      input.disabled = true;
      input.parentNode.querySelector(".btn-increase").disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
      input.parentNode.querySelector(".btn-increase").disabled = false;
    }
  });

  // Lógica 4: Bloquear frigobarInput com valor "1" se geladeiraValue for "1"
  frigobarInputs.forEach((input) => {
    if (geladeiraValue === "1") {
      input.disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
    }
  });

  // Lógica 5: Bloquear geladeiraInput com valor "1" se frigobarValue for "1"
  geladeiraInputs.forEach((input) => {
    if (frigobarValue === "1") {
      input.disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
    }
  });
});

// 10x10 || 10x5
document.addEventListener("change", function (event) {
  const mainProductShapeDiver = document.querySelector(
    "#main-product-shapediver"
  );
  if (!mainProductShapeDiver || mainProductShapeDiver.value === "0") return;

  // Seleciona os inputs relevantes
  const quadroInputs = document.querySelectorAll(
    'input[name="68060fa1-144d-46a0-9f16-1e04e78f3e78"]'
  );
  const salaInputs = document.querySelectorAll(
    'input[name="adf9bd79-369d-45de-aa54-9435ff98483a"]'
  );
  const depositoInputs = document.querySelectorAll(
    'input[name="377c77ec-90e8-4a14-902b-8444535bfcb6"]'
  );

  // Recupera o valor do input selecionado
  const quadroInput = document.querySelector(
    'input[name="68060fa1-144d-46a0-9f16-1e04e78f3e78"]:checked'
  );
  const salaInput = document.querySelector(
    'input[name="adf9bd79-369d-45de-aa54-9435ff98483a"]:checked'
  );
  const depositoInput = document.querySelector(
    'input[name="377c77ec-90e8-4a14-902b-8444535bfcb6"]:checked'
  );

  const quadroValue = quadroInput ? quadroInput.value : null;
  const quadroDataValue = quadroInput ? quadroInput.dataset.quadro : null; // "0" ou "1"
  const salaValue = salaInput ? salaInput.value : null; // "0", "1" ou "2"
  const depositoValue = depositoInput ? depositoInput.value : null; // "0" ou "1"

  // Lógica 1: Bloquear quadro com data-quadro="1" se sala="1" e deposito="1"
  quadroInputs.forEach((input) => {
    if (
      (input.dataset.quadro === "1" &&
        salaValue === "1" &&
        depositoValue === "1") ||
      salaValue === "2"
    ) {
      input.disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
    }
  });

  // Lógica 2: Bloquear deposito se quadro data-quadro="1" estiver value="1" e sala="1"
  depositoInputs.forEach((input) => {
    if (quadroDataValue === "1" && quadroValue === "1" && salaValue === "1") {
      input.disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
    }
  });

  // Lógica 3: Bloquear salaInput com valor "2" se quadroValue não for válido
  salaInputs.forEach((input) => {
    if (
      (input.value === "2" && quadroValue === "1") ||
      (quadroValue === "1" && quadroDataValue === "1" && depositoValue === "1")
    ) {
      input.disabled = true;
      // input.checked = false;
    } else {
      input.disabled = false;
    }
  });
});

// seletor de eventos
document.addEventListener("DOMContentLoaded", function () {
  const eventoSelect = document.getElementById("evento-select");
  const eventoInfo = document.getElementById("evento-info");
  const eventoTitulo = document.querySelectorAll(".event-name");
  const eventoLocal = document.querySelectorAll(".event-local");
  const eventoData = document.querySelectorAll(".event-date");

  if (!eventoSelect) return;

  // Adiciona o evento de mudança no select
  eventoSelect.addEventListener("change", function () {
    const selectedOption = this.options[this.selectedIndex];

    if (selectedOption.value) {
      // Obtém os valores dos atributos data-* da opção selecionada
      const titleText = selectedOption.getAttribute("data-title");
      const localText = selectedOption.getAttribute("data-local");
      const dataText = selectedOption.getAttribute("data-data");

      document.querySelector("#main-product-event-id").value =
        selectedOption.value;
      document.querySelector("#main-product-event-name").value = titleText;
      document.querySelector("#main-product-event-local").value = localText;
      document.querySelector("#main-product-event-date").value = dataText;

      // Atualiza os campos com os dados do evento
      eventoTitulo.forEach((title) => {
        title.textContent = titleText;
      });
      eventoLocal.forEach((local) => {
        local.textContent = localText;
      });
      eventoData.forEach((data) => {
        data.textContent = dataText;
      });

      // Exibe as informações
      eventoInfo.style.display = "block";
    } else {
      // Oculta as informações se nenhum evento for selecionado
      eventoInfo.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Função para atualizar a quantidade
  function updateQuantity(input, increment) {
    const currentValue = parseInt(input.value, 10) || 0;
    const newValue = Math.max(0, Math.min(2, currentValue + increment));
    input.value = newValue;

    const event = new Event("change", { bubbles: true });
    input.dispatchEvent(event);
  }

  // Adiciona ouvintes para os botões de aumentar/diminuir
  document.querySelectorAll(".btn-increase")?.forEach((button) => {
    button.addEventListener("click", () => {
      const input = button.parentElement.querySelector(".quantity-input");
      updateQuantity(input, 1); // Incrementa +1
    });
  });

  document.querySelectorAll(".btn-decrease")?.forEach((button) => {
    button.addEventListener("click", () => {
      const input = button.parentElement.querySelector(".quantity-input");
      updateQuantity(input, -1); // Decrementa -1
    });
  });
});

// Funcionalidade para abrir/fechar as categorias
document.addEventListener("DOMContentLoaded", () => {
  // Seleciona todos os cabeçalhos de categorias
  const categoryHeaders = document.querySelectorAll(".category-block-header");

  // Função para alternar o estado de exibição do conteúdo da categoria
  function toggleCategoryContent(header) {
    const categoryBlock = header.closest(".category-block");
    const content = categoryBlock.querySelector(".category-block-content");
    const plusIcon = header.querySelector(".plus-icon");
    const minusIcon = header.querySelector(".minus-icon");

    // Verifica se o conteúdo está visível
    const isVisible = !content.classList.contains("hidden");

    // Alterna a classe 'hidden' no conteúdo
    if (isVisible) {
      // Fechando o conteúdo
      content.classList.add("hidden");
      plusIcon.style.display = "inline-block";
      minusIcon.style.display = "none";

      // Adiciona uma pequena animação ao ícone
      plusIcon.style.transform = "rotate(90deg)";
      setTimeout(() => {
        plusIcon.style.transform = "rotate(0deg)";
      }, 50);
    } else {
      // Abrindo o conteúdo
      content.classList.remove("hidden");
      plusIcon.style.display = "none";
      minusIcon.style.display = "inline-block";

      // Adiciona uma pequena animação ao ícone
      minusIcon.style.transform = "rotate(90deg)";
      setTimeout(() => {
        minusIcon.style.transform = "rotate(0deg)";
      }, 50);
    }
  }

  // Adiciona evento de clique a cada cabeçalho
  categoryHeaders.forEach((header) => {
    // Inicializa o estado (todas as categorias abertas por padrão)
    const minusIcon = header.querySelector(".minus-icon");
    const plusIcon = header.querySelector(".plus-icon");
    minusIcon.style.display = "inline-block";
    plusIcon.style.display = "none";

    // Adiciona o evento de clique
    header.addEventListener("click", () => {
      toggleCategoryContent(header);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Outras funções já existentes permanecem...

  // Nova função para controlar a visibilidade das seções de mobiliário
  function atualizarVisibilidadeSecoesMobiliario() {
    // Obter o input de sala (modificado para funcionar com input tipo número)
    const salaInput = document.querySelector('input[name="sala"]');

    // Obter todos os inputs de depósito
    const depositoInputs = document.querySelectorAll(
      'input[name*="377c77ec-90e8-4a14-902b-8444535bfcb6"]'
    );

    // Obter o valor selecionado para salas (0, 1 ou 2)
    // Para inputs tipo número, usamos o valor diretamente
    let salaValue = "0";
    if (salaInput) {
      if (salaInput.type === "number") {
        // Se for um input tipo número, verificamos o valor numérico
        const numValue = parseInt(salaInput.value) || 0;
        if (numValue > 1) {
          salaValue = "2"; // Se for mais de 1, tratamos como "2 salas"
        } else if (numValue > 0) {
          salaValue = "1"; // Se for 1, tratamos como "1 sala"
        } else {
          salaValue = "0"; // Se for 0, tratamos como "sem sala"
        }
      } else if (salaInput.type === "radio" && salaInput.checked) {
        // Mantém compatibilidade com inputs tipo radio
        salaValue = salaInput.value;
      }
    }

    // Verificar se algum depósito está marcado como sim
    let temDeposito = false;
    depositoInputs.forEach((input) => {
      if (
        input.checked &&
        input.value === "1" &&
        input.dataset.deposito === "1"
      ) {
        temDeposito = true;
      }
    });

    // Encontrar as seções de mobiliário usando seletores compatíveis
    let secaoSala1 = null;
    let secaoSala2 = null;
    let secaoDeposito = null;

    // Obter todas as seções de mobiliário
    const todasSecoes = document.querySelectorAll(".mobiliario-section");
    todasSecoes.forEach((secao) => {
      const titulo = secao.querySelector(".section-title");
      if (titulo) {
        if (titulo.textContent.includes("Sala 1")) {
          secaoSala1 = secao;
        } else if (titulo.textContent.includes("Sala 2")) {
          secaoSala2 = secao;
        } else if (titulo.textContent.includes("Depósito")) {
          secaoDeposito = secao;
        }
      }
    });

    // Aplicar lógica de visibilidade para Sala 1
    if (secaoSala1) {
      if (salaValue === "0") {
        secaoSala1.style.display = "none";
      } else {
        secaoSala1.style.display = "block";
      }
    }

    // Aplicar lógica de visibilidade para Sala 2
    if (secaoSala2) {
      if (salaValue === "2") {
        secaoSala2.style.display = "block";
      } else {
        secaoSala2.style.display = "none";
      }
    }

    // Aplicar lógica de visibilidade para Depósito
    if (secaoDeposito) {
      if (temDeposito) {
        secaoDeposito.style.display = "block";
      } else {
        secaoDeposito.style.display = "none";
      }
    }
  }

  // Executar a função de visibilidade ao carregar a página
  atualizarVisibilidadeSecoesMobiliario();

  // Adicionar listener para atualizar a visibilidade quando houver mudanças
  document.addEventListener("change", function (event) {
    // Verificar se a mudança é em um input relevante para nossa lógica
    if (
      event.target.name &&
      (event.target.name.includes("sala") || // Sala
        event.target.name.includes("377c77ec-90e8-4a14-902b-8444535bfcb6")) // Depósito
    ) {
      atualizarVisibilidadeSecoesMobiliario();
    }
  });

  // Adicionar evento aos botões de aumento/diminuição para atualizar visibilidade
  document.querySelectorAll(".btn-quantity").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.parentElement.querySelector(".quantity-input");
      if (
        input &&
        (input.name.includes("adf9bd79-369d-45de-aa54-9435ff98483a") ||
          input.name.includes("377c77ec-90e8-4a14-902b-8444535bfcb6"))
      ) {
        setTimeout(() => {
          atualizarVisibilidadeSecoesMobiliario();
        }, 0);
      }
    });
  });
});

// Função para controlar a quantidade máxima combinada entre mesas e bistrôs
function atualizarLimitesMesasBistros() {
  // Selecionamos os inputs de mesa e bistrô
  const hallMesaInput = document.querySelector(
    'input[data-name="682e8931-33e5-4179-8952-f9bf2e01e5c3"]'
  ); // mesas
  const hallBistroInput = document.querySelector(
    'input[data-name="3b3ea4bc-02bf-4c28-b5f2-b7da7956964d"]'
  ); // bistrôs

  // Se algum dos inputs não estiver na página, não prosseguimos
  if (!hallMesaInput || !hallBistroInput) return;

  // Obter os valores atuais
  const mesaValue = parseInt(hallMesaInput.value) || 0;
  const bistroValue = parseInt(hallBistroInput.value) || 0;

  // Soma total (não deve exceder 3)
  const total = mesaValue + bistroValue;

  // Obter os botões de aumento e diminuição para ambos os inputs
  const btnIncreaseMesa =
    hallMesaInput.parentElement.querySelector(".btn-increase");
  const btnDecreaseMesa =
    hallMesaInput.parentElement.querySelector(".btn-decrease");
  const btnIncreaseBistro =
    hallBistroInput.parentElement.querySelector(".btn-increase");
  const btnDecreaseBistro =
    hallBistroInput.parentElement.querySelector(".btn-decrease");

  // Resetar estado dos botões
  btnIncreaseMesa.disabled = false;
  btnIncreaseBistro.disabled = false;
  hallMesaInput.disabled = false;
  hallBistroInput.disabled = false;

  // Aplicar lógica de limitação

  // Se já alcançou o total máximo (3)
  if (total >= 3) {
    btnIncreaseMesa.disabled = true;
    btnIncreaseBistro.disabled = true;
  }

  // Se mesas já tem 3, desabilita completamente os controles de bistrô
  if (mesaValue >= 3) {
    btnIncreaseBistro.disabled = true;
    hallBistroInput.value = 0; // Força o valor para 0
    hallBistroInput.disabled = true;
  }

  // Se bistrô já tem 3, desabilita completamente os controles de mesa
  if (bistroValue >= 3) {
    btnIncreaseMesa.disabled = true;
    hallMesaInput.value = 0; // Força o valor para 0
    hallMesaInput.disabled = true;
  }

  // Se mesas tem 2, limite bistrô a 1
  if (mesaValue === 2 && bistroValue > 1) {
    hallBistroInput.value = 1;
  }

  // Se bistrô tem 2, limite mesas a 1
  if (bistroValue === 2 && mesaValue > 1) {
    hallMesaInput.value = 1;
  }

  // Botão de aumento de mesa desabilitado se não pode aumentar mais
  if (mesaValue + bistroValue >= 3 || mesaValue >= 3) {
    btnIncreaseMesa.disabled = true;
  }

  // Botão de aumento de bistrô desabilitado se não pode aumentar mais
  if (mesaValue + bistroValue >= 3 || bistroValue >= 3) {
    btnIncreaseBistro.disabled = true;
  }

  // Limite de mesas é 3-bistrô
  hallMesaInput.setAttribute("max", 3 - bistroValue);

  // Limite de bistrô é 3-mesas
  hallBistroInput.setAttribute("max", 3 - mesaValue);
}

document.addEventListener("DOMContentLoaded", () => {
  // Adicionar listener para o evento change em todos os inputs de tipo número
  document.querySelectorAll(".quantity-input").forEach((input) => {
    // Executar a verificação inicial
    if (
      input.dataset.name === "682e8931-33e5-4179-8952-f9bf2e01e5c3" ||
      input.dataset.name === "3b3ea4bc-02bf-4c28-b5f2-b7da7956964d"
    ) {
      atualizarLimitesMesasBistros();
    }

    // Adicionar evento para quando o valor for alterado
    input.addEventListener("change", () => {
      if (
        input.dataset.name === "682e8931-33e5-4179-8952-f9bf2e01e5c3" ||
        input.dataset.name === "3b3ea4bc-02bf-4c28-b5f2-b7da7956964d"
      ) {
        atualizarLimitesMesasBistros();
      }
    });
  });

  // Adicionar evento aos botões de aumento/diminuição
  document.querySelectorAll(".btn-quantity").forEach((button) => {
    button.addEventListener("click", () => {
      const input = button.parentElement.querySelector(".quantity-input");
      if (
        input &&
        (input.dataset.name === "682e8931-33e5-4179-8952-f9bf2e01e5c3" ||
          input.dataset.name === "3b3ea4bc-02bf-4c28-b5f2-b7da7956964d")
      ) {
        // Dar tempo para o valor ser atualizado
        setTimeout(() => {
          atualizarLimitesMesasBistros();
        }, 10);
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // 1. Encontra o botão de download dentro do modal específico
  const downloadBtn = document.querySelector(
    '.modal[data-target="doc-pdf"] .dialog-button-primary'
  ); //

  if (downloadBtn) {
    downloadBtn.addEventListener("click", function () {
      const btn = this;
      const btnTextSpan = btn.querySelector("span");
      const originalText = btnTextSpan.textContent;

      // 2. Verifica se as bibliotecas foram carregadas
      if (
        typeof html2canvas === "undefined" ||
        typeof window.jspdf === "undefined"
      ) {
        alert(
          "Erro: As bibliotecas para gerar o PDF não foram carregadas. Tente recarregar a página."
        );
        return;
      }

      // 3. Adiciona um estado de "loading" ao botão
      btn.disabled = true;
      btnTextSpan.textContent = "Gerando...";

      // 4. Seleciona o conteúdo que será transformado em PDF
      const contentToDownload = document.querySelector(
        '.modal[data-target="doc-pdf"] .doc-pdf-content-wrapper'
      ); //

      // 5. Pega o ID do pedido para o nome do arquivo
      let orderID = "Memorial-Descritivo"; // Nome padrão
      try {
        const orderIDElement = contentToDownload.querySelector("h4 > strong"); //
        if (orderIDElement) {
          orderID = "Pedido-" + orderIDElement.textContent.trim();
        }
      } catch (e) {}

      const fileName = `${orderID}.pdf`;

      // 6. Usa html2canvas para "fotografar" o conteúdo
      html2canvas(contentToDownload, {
        scale: 2, // Aumenta a resolução da "foto"
        useCORS: true, // Permite carregar imagens (se houver)
      }).then((canvas) => {
        try {
          const imgData = canvas.toDataURL("image/png");
          const { jsPDF } = window.jspdf;

          // Configurações do PDF (A4: 210mm x 297mm)
          const pdfWidth = 210;
          const pdfHeight = 297;
          const margin = 10; // Margem de 10mm

          // Dimensões da imagem do canvas
          const imgWidth = canvas.width;
          const imgHeight = canvas.height;

          // Calcula a proporção para caber a imagem na página
          const ratio = Math.min(
            (pdfWidth - margin * 2) / imgWidth,
            (pdfHeight - margin * 2) / imgHeight
          );

          const finalImgWidth = imgWidth * ratio;
          const finalImgHeight = imgHeight * ratio;

          // Calcula posição para centralizar a imagem
          const x = (pdfWidth - finalImgWidth) / 2;
          const y = margin;

          // 7. Cria o PDF e adiciona a imagem
          const pdf = new jsPDF("p", "mm", "a4"); // Retrato, milímetros, A4
          pdf.addImage(imgData, "PNG", x, y, finalImgWidth, finalImgHeight);

          // 8. Salva o arquivo
          pdf.save(fileName);
        } catch (e) {
          console.error("Erro ao gerar o PDF:", e);
          alert("Ocorreu um erro ao gerar o PDF.");
        } finally {
          // 9. Restaura o botão ao estado original
          btn.disabled = false;
          btnTextSpan.textContent = originalText;
        }
      });
    });
  }
});

function verificarVisibilidadeUploadQuadro() {
  const containerUpload = document.querySelector(".quadro-container");

  const seletorEstrutura =
    'input[data-name="68060fa1-144d-46a0-9f16-1e04e78f3e78"]:checked';
  const inputEstrutura = document.querySelector(seletorEstrutura);

  if (!containerUpload) return;
  if (inputEstrutura && inputEstrutura.value === "1") {
    containerUpload.style.display = "block";
  } else {
    containerUpload.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  verificarVisibilidadeUploadQuadro();

  document.addEventListener("change", (event) => {
    if (event.target.dataset.name === "68060fa1-144d-46a0-9f16-1e04e78f3e78") {
      verificarVisibilidadeUploadQuadro();
    }
  });

  window.addEventListener("draft:summary_applied", () => {
    setTimeout(verificarVisibilidadeUploadQuadro, 200);
  });
});
